import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const BestSales = () => {
  return (
    <>
    <Navbar/>
    <div>
      Best Sales
    </div>
    <Footer/>
    </>
  )
}

export default BestSales
